import { Typography, Box } from '@mui/material';
import CountdownTimer from '../components/CountdownTimer';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { HeroSection, HeroContent, PrimaryButton } from '../styles/components';
import { typographyMixins } from '../styles/mixins';

function Home() {
  const navigate = useNavigate();
  
  // JSON-LD structured data for the wedding event
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": "Sam Musso and Alexa Ballenger Wedding",
    "startDate": "2025-08-02T16:00:00",
    "endDate": "2025-08-02T23:00:00",
    "location": {
      "@type": "Place",
      "name": "Echo Mountain",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Echo Mountain",
        "addressRegion": "CO",
        "addressCountry": "US"
      }
    },
    "description": "Join us for the wedding celebration of Sam Musso and Alexa Ballenger at Echo Mountain, Colorado",
    "organizer": {
      "@type": "Person",
      "name": "Sam Musso and Alexa Ballenger"
    },
    "url": "https://www.happilyevermoose.com",
    "image": "https://www.happilyevermoose.com/echo_mountain.jpg"
  };

  return (
    <>
      <Helmet>
        <title>Sam Musso & Alexa Ballenger Wedding | August 2, 2025 | Echo Mountain, CO</title>
        <meta name="description" content="Join us for the wedding of Sam Musso and Alexa Ballenger on August 2, 2025 at Echo Mountain, Colorado. RSVP and find travel information for our special day at happilyevermoose.com." />
        <meta name="keywords" content="Sam Musso, Alexa Ballenger, wedding, Echo Mountain, Colorado wedding, August 2 2025, mountain wedding, RSVP, happilyevermoose" />
        <meta property="og:title" content="Sam Musso & Alexa Ballenger Wedding" />
        <meta property="og:description" content="Sam Musso and Alexa Ballenger are getting married on August 2, 2025 at Echo Mountain, Colorado. Join us for our special day!" />
        <meta property="og:image" content="/echo_mountain.jpg" />
        <meta property="og:url" content="https://www.happilyevermoose.com" />
        <meta property="og:site_name" content="Sam & Alexa's Wedding" />
        <link rel="canonical" href="https://www.happilyevermoose.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <HeroSection sx={{ backgroundImage: 'url(/echo_mountain.jpg)' }}>
        <HeroContent>
          <Typography
            variant="h2" 
            component="h1"
            sx={{
              mb: 1,
              fontWeight: 700,
              fontSize: { xs: '2.5rem', sm: '3.75rem' },
              whiteSpace: 'nowrap'
            }}
          >
            Alexa & Sam
          </Typography>
          
          <Typography
            variant="h3"
            component="p"
            sx={{
              mb: 2,
              fontSize: { xs: '2rem', sm: '3rem' }
            }}
          >
            8/2/2025
          </Typography>
          
          <Box 
            sx={{ 
              width: '15em', 
              height: '1px', 
              bgcolor: 'black', 
              mx: 'auto', 
              my: 0
            }} 
          />
          
          <Typography
            variant="h5" 
            component="p"
            sx={{
              ...typographyMixins.subtitle,
              mb: 2,
              mt: 2,
              fontSize: { xs: "1.5em", sm: "2em" },
              whiteSpace: 'nowrap',
              letterSpacing: 2,
            }}
          >
            Echo Mountain, CO
          </Typography>

          <PrimaryButton
            variant="contained"
            size="large"
            onClick={() => navigate('/rsvp')}
            sx={{
              mt: 3,
              mb: 4,
              px: 8,
            }}
          >
            RSVP
          </PrimaryButton>
          
          <CountdownTimer />
        </HeroContent>
      </HeroSection>
    </>
  );
}

export default Home;
